import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { AmountPayments, PaymentsSchedule } from '@checkout-v2/const';
import { getPaymentDates } from '@checkout-v2/utils';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-payment-schedule',
  templateUrl: './payment-schedule.component.html',
  styleUrls: ['./payment-schedule.component.scss'],
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentScheduleComponent implements OnInit {
  amountPayments$: BehaviorSubject<AmountPayments> = new BehaviorSubject<AmountPayments>(AmountPayments.FourPayments);
  cartTotals$: Observable<number | undefined>;
  paymentsSchedule$: Observable<PaymentsSchedule | undefined>;
  readonly AmountPaymentsEnum = AmountPayments;

  constructor(private activeCartService: ActiveCartService) {}

  ngOnInit(): void {
    this.cartTotals$ = this.activeCartService.getActive().pipe(map((cart) => cart.totalPrice && cart.totalPrice.value));

    this.paymentsSchedule$ = combineLatest({
      cartTotals: this.cartTotals$,
      amountPayments: this.amountPayments$,
    }).pipe(
      map(({ amountPayments, cartTotals }) => {
        if (amountPayments === AmountPayments.FourPayments) {
          if (!cartTotals) return;
          const paymentDates = getPaymentDates([14, 28, 42]);
          const paymentSum = +(cartTotals * 0.25).toFixed(1);

          return {
            amountPayments: AmountPayments.FourPayments,
            paymentsDates: ['Сегодня', ...paymentDates],
            paymentSum,
          };
        } else if (amountPayments === AmountPayments.SixPayments) {
          if (!cartTotals) return;

          const firstPayment = cartTotals * 0.25;
          const otherPayments = +(cartTotals * 0.15).toFixed(1);

          return {
            amountPayments: AmountPayments.SixPayments,
            firstPayment: +firstPayment.toFixed(1),
            otherPayments: otherPayments,
          };
        }
      }),
    );
  }

  setAmountPayments(amountPayments: AmountPayments): void {
    this.amountPayments$.next(amountPayments);
  }
}
